import axios from '@/settings/axios'
import { apiSettings } from "@/settings/api"
let base = '/newsletter/';

export default {
    subscribe(request = {}, version = apiSettings.subscribe_ver) {
        return axios.post(base + version + '/mailing', request);
    },
}